function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.666 13.667H11.542l4.402-4.383a1.337 1.337 0 000-1.892 1.34 1.34 0 00-1.894 0l-6.67 6.661a1.332 1.332 0 00-.28.44 1.33 1.33 0 000 1.012c.064.164.159.313.28.44l6.67 6.66a1.335 1.335 0 001.894 0 1.331 1.331 0 000-1.89l-4.402-4.384h10.124a1.333 1.333 0 100-2.664z",
  id: "path-arrow-forward-right"
})), /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  transform: "matrix(-1 0 0 1 23 -7)",
  xlinkHref: "#path-arrow-forward-right",
  fillRule: "evenodd"
})));